import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "kl-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit, OnDestroy {
  subscription: Subscription;

  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }
}
